import {useContext, useMemo} from 'react'
import roleContext from '../context/roleContext'
import {FeatureKey} from '../features/featureRegistry'

export const useFeatureAccess = (featureKey: FeatureKey) => {
  const roleState = useContext(roleContext)
  const canAccess = useMemo(() => {
    // Super Admin always has access
    if (roleState.roleName?.toLowerCase() === 'super admin') return true
    // Fallback if features array missing
    const features = roleState.features || []
    return features.includes(featureKey)
  }, [roleState.roleName, roleState.features, featureKey])

  return canAccess
}

export default useFeatureAccess



